import { VariableKeyBox } from "../key-box";

interface Props {
  nodeId: string;
  nodeName: string;
}

export const ExecutionStartTimestamp = ({ nodeName }: Props) => {
  return (
    <div className="flex">
      <div className="w-0.5 relative bg-neutral-object-accent translate-x-[25px]">
        <span className="absolute left-3 top-[14px] w-2 h-2 bg-neutral-object-accent rounded-full"></span>
        <span className="absolute w-3 h-5 border-l-2 border-t-2 border-neutral-object-accent rotate-x-180 rounded-tl-md"></span>
      </div>

      <div className="relative pl-[50px] w-full">
        <div className="py-1">
          <div className="space-y-3">
            <VariableKeyBox
              name="inicio-nodo"
              type="date"
              value={`Timestamp de inicio de ejecución del nodo: ${nodeName}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const ExecutionEndTimestamp = ({ nodeName }: Props) => {
  return (
    <div className="flex">
      <div className="w-0.5 relative translate-x-[25px]">
        <div className="absolute top-0 left-0 h-[14px] bg-neutral-object-accent" />
        <span className="absolute left-3 top-[14px] w-2 h-2 bg-neutral-object-accent rounded-full"></span>
        <span className="absolute w-3 h-5 border-l-2 border-t-2 border-neutral-object-accent rotate-x-180 rounded-tl-md"></span>
      </div>

      <div className="relative pl-[50px] w-full">
        <div className="py-1">
          <div className="space-y-3">
            <VariableKeyBox
              name="fin-nodo"
              type="date"
              value={`Timestamp de fin de ejecución del nodo: ${nodeName}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
